import { defineComponent as _defineComponent } from 'vue'
import { CloseBold } from '@element-plus/icons-vue';
import { computed, PropType, reactive, ref, watch } from 'vue';
import { PUSH_TYPE_MAP, MI_PUSH, OPPO_PUSH, VIVO_PUSH, COMMON_PUSH, CONFIG_MAPPING, CONFIG_TYPES, NOTIFICATION_TYPES, PUSH_TYPES, PUSH_VOIP_TYPES } from '../constance';
import { FormFileType } from '../types';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'editConfig',
  props: {
  editVisible: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  title: {
    type: String as PropType<string>,
    default: () => '',
  },
  editKey: {
    type: String as PropType<string>,
    default: () => '',
  },
  data: {} as any,
  appInfo: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
},
  emits: ['close', 'save'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emits = __emit;

const props = __props;

const callbackForm = ref({
  onlineStatus: '',
  voiceStatus: '',
});

const formData = ref();
const formRef = ref();
const originalBundleId = ref('');

//修复bug:每次弹窗打开都同步一次数据，避免重复打开页面回显的数据消失
watch(
  () => props.editVisible,
  (visible) => {
    if (visible) {
      if (Array.isArray(props.data)) {
        callbackForm.value = { onlineStatus: '', voiceStatus: '' };
        props.data.forEach((item: any) => {
          if (item.callbackUrlType === 1) {
            callbackForm.value.onlineStatus = item.url;
          } else if (item.callbackUrlType === 2) {
            callbackForm.value.voiceStatus = item.url;
          }
        });
      } else {
        // 获取当前表单需要的所有字段，补齐formData
        const fields = (currentField.value || []).map(f => f.model);
        const base: Record<string, any> = {};
        fields.forEach(key => {
          base[key] = props.data?.[key] ?? '';
        });
        formData.value = { ...base, ...props.data };
        originalBundleId.value = props.data.bundleId; // 记录原始bundleId
      }
    }
  }
);


const currentField = computed(() => {

  let fields: Array<FormFileType> = [];
  if (props.editKey === 'miConfig') {
    fields = CONFIG_MAPPING['miPush']["fields"]
  }
  else if (props.editKey === 'oppoConfig') {
    fields = CONFIG_MAPPING['oppoPush']["fields"]
  }
  else if (props.editKey === 'vivoConfig') {
    fields = CONFIG_MAPPING['vivoPush']["fields"]
  }
  else if (props.editKey === 'hmsConfig') {
    fields = CONFIG_MAPPING['commonPush']["fields"]
  }
  else if (props.editKey === 'oneSignalConfig') {
    if (props.data.configType == 0 && props.data.pushPlateform == 0) //安卓普通推送
    {
      fields = CONFIG_MAPPING['androidOrdinary']["fields"]
    }
    else if (props.data.configType == 1 && props.data.pushPlateform == 0) //安卓VOIP推送
    {
      fields = CONFIG_MAPPING['androidVOIP']["fields"]
    }
    else if (props.data.configType == 0 && props.data.pushPlateform == 1) //IOS普通推送
    {
      fields = CONFIG_MAPPING['iosOrdinary']["fields"]
    }
    else if (props.data.configType == 1 && props.data.pushPlateform == 1) //IOSVOIP推送
    {
      fields = CONFIG_MAPPING['iosVOIP']["fields"]
    }
  }
  else if (props.editKey === 'jConfig') {
    fields = CONFIG_MAPPING['commonPush']["fields"]
  }
  if (fields && fields.length > 0) {
    return fields.map((item) => {
      let data = {
        label: item.label,
        props: item.model,
        model: item.model,
        placeholder: item.placeholder,
        ruler: item.ruler,
      };
      return data;
    });
  }


  // return Object.entries(props.data).map((item) => {
  //   return {
  //   label: formatLabel(item[0]),
  //   props: item[0],
  //   model: item[0],
  //   placeholder: `请输入${formatLabel(item[0])}`,
  //   ruler: item[0] === 'iosSound' ? [] : [{ required: true, message: `请输入${formatLabel(item[0])}`, trigger: 'blur' }],
  //   };
  // });

});

const subTitle = computed(() => {
  if (Array.isArray(props.data)) return '回调API';
  if (props.title === '华为HMS推送配置') return '普通推送';
  if (props.title === '小米推送配置') return '普通推送';
  if (props.title === 'OPPO推送配置') return '普通推送';
  if (props.title === 'VIVO推送配置') return '普通推送';
  const { configType, pushPlateform } = props.data as any;
  if (configType === 0 && pushPlateform === 1) {
    return 'IOS普通推送';
  }
  if (configType === 1 && pushPlateform === 1) {
    return 'IOS VOIP推送';
  }
  if (configType === 0 && pushPlateform === 0) {
    return 'Android普通推送';
  }
  if (configType === 1 && pushPlateform === 0) {
    return 'Android VOIP推送';
  }
});


const formatLabel = (fieldName: string) => {
  switch (fieldName) {
    case 'appKey':
      return 'Appkey';
    case 'appId':
      return '应用Id';
    case 'appSecret':
      return 'AppSecret';
    case 'iosSound':
      return '推送声音文件名';
    case 'bundleId':
      return '应用包名';
  }
};

const handleClose = () => {
  formData.value = {};
  callbackForm.value = { onlineStatus: '', voiceStatus: '' };
  emits('close');
};

const confirm = () => {
  if (subTitle.value === '回调API') {
    const { onlineStatus, voiceStatus } = callbackForm.value;
    let callbackUrls = [
      { callbackUrlType: 1, url: onlineStatus },
      { callbackUrlType: 2, url: voiceStatus },
    ];
    emits('save', callbackUrls);
  } else {
    if (!formRef.value) return;

    // 去除所有字符串字段的前后空格,防止判断的时候出错
    Object.keys(formData.value).forEach(key => {
      if (typeof formData.value[key] === 'string') {
        formData.value[key] = formData.value[key].trim();
      }
    });
    formRef.value.validate((valid: boolean) => {
      if (valid) {
        // 校验同类型下包名唯一
        const configList = props.appInfo[props.editKey] || [];
        const isExist = configList.some((item: any) =>
          item.pushPlateform == formData.value.pushPlateform &&
          item.configType == formData.value.configType &&
          item.bundleId === formData.value.bundleId &&
          item.bundleId !== originalBundleId.value
        );
        if (isExist) {
          ElMessage.warning('应用包名已存在，请重新修改');
          return;
        }
        emits('save', formData.value, props.title, originalBundleId.value);
      }
    });
  }
};

const __returned__ = { emits, props, callbackForm, formData, formRef, originalBundleId, currentField, subTitle, formatLabel, handleClose, confirm, get CloseBold() { return CloseBold } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})